import { render } from "./EmailCapture.vue?vue&type=template&id=310f5107&scoped=true"
import script from "./EmailCapture.vue?vue&type=script&lang=js"
export * from "./EmailCapture.vue?vue&type=script&lang=js"

import "./EmailCapture.vue?vue&type=style&index=0&id=310f5107&lang=postcss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-310f5107"]])

export default __exports__